'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseIcons = require('@bibliocommons/base-icons');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

require('../styles/RemoveButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  className: _react2.default.PropTypes.string,
  handleClick: _react2.default.PropTypes.func,
  tagName: _react2.default.PropTypes.string,
  isLoading: _react2.default.PropTypes.bool
};

var RemoveButton = function (_BcReactComponent) {
  _inherits(RemoveButton, _BcReactComponent);

  function RemoveButton(props) {
    _classCallCheck(this, RemoveButton);

    var _this = _possibleConstructorReturn(this, (RemoveButton.__proto__ || Object.getPrototypeOf(RemoveButton)).call(this, props));

    _this.bindAll('handleClick');
    return _this;
  }

  _createClass(RemoveButton, [{
    key: 'getButtonClassName',
    value: function getButtonClassName() {
      return 'cp-remove-btn btn btn-remove ' + this.props.className;
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      if (this.props.handleClick && !this.props.isLoading) {
        e.preventDefault();
        this.props.handleClick();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var Tag = this.props.tagName;
      return _react2.default.createElement(
        Tag,
        { onClick: this.handleClick, className: this.getButtonClassName() },
        this.props.isLoading ? _react2.default.createElement(_baseIcons.Spinner, { color: '#FFF' }) : _react2.default.createElement(_baseIcons.Remove, { className: 'icon-svg-remove small', width: '12', height: '12' })
      );
    }
  }]);

  return RemoveButton;
}(_baseBcReactComponent2.default);

RemoveButton.propTypes = propTypes;
RemoveButton.defaultProps = {
  tagName: 'button',
  isLoading: false
};

exports.default = RemoveButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-buttons/lib/components/remove/components/RemoveButton.component.js
// module id = 435
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 15